import { Button, Col, Divider, Dropdown, Flex, Grid, Row, Space } from 'antd';
import { ChevronDown } from 'lucide-react';
import Link from 'next/link';
import { FC } from 'react';
import styles from './BoatsMenu.module.scss';
import { BoatsMenuProps } from './BoatsMenu.props';
import { MobileBoatsMenu } from './MobileBoatsMenu';
import { navigationGroups } from './navigationGroups';
import SectionItem from './SectionItem';

const BoatsMenu: FC<BoatsMenuProps> = (props) => {
  const { xl } = Grid.useBreakpoint();
  // const { data } = useNavigation({ navigationIdOrSlug: '1' });

  if (xl) {
    return (
      <Dropdown
        {...props}
        rootClassName={styles.rootClassName}
        popupRender={() => (
          <div className={styles.containerDropdown}>
            <Row gutter={12}>
              {navigationGroups.map((group, index) => (
                <Col sm={6} key={index}>
                  <SectionItem {...group} />
                </Col>
              ))}
            </Row>
            <Divider>Or</Divider>
            <div className={styles.footer}>
              <Link href="/boats">
                <Button type="primary" size="large">
                  Explore all boats
                </Button>
              </Link>
            </div>
          </div>
        )}
      >
        <Flex align="center" gap={8}>
          <span>Boats</span>
          <ChevronDown size={16} />
        </Flex>
      </Dropdown>
    );
  }

  return <MobileBoatsMenu items={navigationGroups} />;
};

export { BoatsMenu };
